<script>
import moment from 'moment-timezone'
import { longerHourDurationFormatted } from '../../clavo-shared/functions/time'
const { emojis } = require('../../clavo-shared/constants/index')
import EventBus from '@/EventBus'
import Vue from 'vue'

export default {
  data() {
    return {
      allDataRefreshed: false,
    }
  },
  mounted() {
    // this.mountStripeScript()
    EventBus.$on('api-fixed', this.apiFixed)
  },
  beforeDestroy() {
    EventBus.$off('api-fixed', this.apiFixed)
  },
  methods: {
    async apiFixed() {
      if (!this.allDataRefreshed) {
        await this.load()
      }
    },
    async load() {},
    showServerError(response, defaultKey) {
      let msg
      if (response.error) {
        if (response.errorData) {
          msg = this.$t('errors.' + response.error, response.errorData)
        } else {
          msg = this.$t('errors.' + response.error)
          if (msg === response.error) {
            msg = this.$t('errors.' + defaultKey)
          }
          if (msg === response.error) {
            msg = this.$t('errors._genericServerError')
          }
        }
      } else if (response.code) {
        msg = this.$t('errors._genericServerError')
      }
      if (!response.code || response.code !== 100) {
        // server error, we show it on top banner
        EventBus.$emit('new-info-bar-msg', {
          msg,
          error: true,
        })
      }
    },
    showError(key) {
      let msg = this.$t('errors.' + key)
      EventBus.$emit('new-info-bar-msg', {
        msg,
        error: true,
      })
    },
    showMessage(key, params) {
      let msg
      if (params) {
        msg = this.$t(key, params)
      } else {
        msg = this.$t(key)
      }

      EventBus.$emit('new-info-bar-msg', {
        msg,
      })
    },
    getErrorTranslated(errorCode, defaultKey) {
      let ret = this.$t(translateCode[errorCode])
      if (!ret) {
        ret = this.$t('errors.' + defaultKey)
      }
      return ret
    },
    texts(arg) {
      return {
        maxMembersFree: 5,
        defaultColorNumber: 6,
        // settings: {
        //   userProfile: {
        //     incorrectValueMsg: {
        //       email: 'Enter properggg email address.',
        //       phone: '',
        //       name: '',
        //     },
        //   },
        //   preferences: {
        //   workScheduleDeadlineDesc: 'You\'re asked to let the others know about your' + 'work schedule for the next week till:',
        //   workScheduleDesc: 'How many hours you work every week.',
        //   holidaysDesc: 'How much leave days you have left this year.',
        //   workingHoursFooter: 'per week',
        //   holidaysFooter: 'this year',
        //   },
        //   workSchedule: {
        //    notificationAdditionalInfo: 'You can turn off the requirement of submitting' + ' the working schedule for the admin (owner) of the team.',
        //    timeOffDesc: 'Default value of holiday days in the year.',
        //   },
        // },
        popup: {
          deleteAccount: {
            user: {
              confirmation: this.$t('deleteUserAccountAreYouSure'),
              warning: this.$t('thisCannotBeUndone'),
              terms: [
                this.$t('termsHistoryNotAccessible'), //
                this.$t('termsAllPersonalInfoDestroyed'),
                this.$t('termsNotAbleToRestoreAccount'),
              ],
            },
            team: {
              confirmation: this.$t('deleteTeamAccountAreYouSure'),
              warning: this.$t('thisCannotBeUndone'),
              terms: [
                this.$t('termsAllTeamScheduleNotAccessible'), //
                this.$t('termsAllTeamInfoDestroyed'),
                this.$t('termsNotAbleToRestoreTeamAccount'),
              ],
            },
            cancelSubscription: {
              warning: this.$t('thisCannotBeUndone'),
              terms: [
                this.$t('termsTeamDowngradedTo5Members'), //
                this.$t('termsNoAbleToCreateMoreFreeTeams'),
              ],
            },
          },
        },
        // location: {
        //  removeWarning: 'Are you sure you want to delete ' + arg + ' location? This cannot be undone.',
        //  emptyName: 'Location name cannot be empty.',
        //  multipleLocationsMainInfo: 'Based on team members\' location',
        //  multipleLocationsAdditionalInfo: 'E.g. remote work across different time zones.',
        // },
        momentDayNames: {
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          lastDay: '[Yesterday]',
          lastWeek: 'dddd',
          sameElse: 'dddd',
        },
      }
    },
    localizedError(error) {
      let key = translateCode(error)
      return $t(key)
    },
    hoursFormatWithFractions(is24, divideHour) {
      if (!divideHour) {
        divideHour = 1
      }
      let hours = []
      for (let i = 0; i < 24 * divideHour; i++) {
        hours.push({
          name: moment('00:00', 'HH:mm')
            .add((i * 60) / divideHour, 'minutes')
            .format(is24 ? 'HH:mm' : 'h:mm A'),
          value: moment('00:00', 'HH:mm')
            .add((i * 60) / divideHour, 'minutes')
            .format('HH:mm'),
        })
      }
      return hours
    },
    teamNotificationKeys() {
      return [
        { name: this.$t('timeOffs'), key: 'time-offs' },
        { name: this.$t('scheduleChanges'), key: 'after-deadline-changes' },
        { name: this.$t('missedDeadline'), key: 'missed-deadline' },
        { name: this.$t('deadlineChanges'), key: 'deadline-changes' },
      ]
    },
    locationTags() {
      return [
        { name: this.$t('office'), value: 'office' },
        { name: this.$t('remoteWork'), value: 'remote' },
        // {name: this.$t('home'), value: 'home'},
        // {name: this.$t('training'), value: 'training'},
        // {name: this.$t('conference'), value: 'conference'},
        // {name: this.$t('fairs'), value: 'fair'},
        // {name: this.$t('workshop'), value: 'workshop'},
        // // {name: this.$t('atClient'), value: 'at-client'},
        // {name: this.$t('fieldwork'), value: 'fieldwork'},
        // {name: this.$t('warehouse'), value: 'warehouse'},
        // {name: this.$t('store'), value: 'store'},
      ]
    },

    hourFormatOptions() {
      return [
        { name: this.$t('hourFormatOptions')[0], value: true },
        { name: this.$t('hourFormatOptions')[1], value: false },
      ]
    },
    longerDurationFormat(start_date, end_date, hourShortBoolean) {
      let i18nTimeFormat = hourShortBoolean ? 'hoursShort' : 'hoursPlural'
      let timeObj = longerHourDurationFormatted(start_date, end_date)
      let time = timeObj.time
      time = time + (hourShortBoolean ? '' : ' ')
      if (timeObj.minutes === 0 && timeObj.hours === 1) {
        time = time + this.$tc(i18nTimeFormat, 1)
      } else {
        time = time + this.$tc(i18nTimeFormat, 2)
      }
      return time
    },
    daysOffTypes() {
      return [
        {
          name: this.$t('paid'),
          value: 'holiday',
          color: '#F6E4BB',
          icon: require('@/assets/_desktop/_calendars/holiday_14px.svg'),
          image: require('@/assets/_desktop/_calendars/Holidays.svg'),
        },
        {
          name: this.$t('unpaid'),
          value: 'days-off',
          color: '#EBD2AE',
          icon: require('@/assets/_desktop/_calendars/smile_14px.svg'),
          image: require('@/assets/_desktop/_calendars/Day-Off.svg'),
        },
        {
          name: this.$t('sick'),
          value: 'sick',
          color: '#FAD3B2',
          icon: require('@/assets/_desktop/_calendars/sick_14px.svg'),
          image: require('@/assets/_desktop/_calendars/Sickness.svg'),
        },
      ]
    },
    weekdays(startingDay) {
      let week = [
        { name: this.$t('weekDay')[0], value: 'Sunday' },
        { name: this.$t('weekDay')[1], value: 'Monday' },
        { name: this.$t('weekDay')[2], value: 'Tuesday' },
        { name: this.$t('weekDay')[3], value: 'Wednesday' },
        { name: this.$t('weekDay')[4], value: 'Thursday' },
        { name: this.$t('weekDay')[5], value: 'Friday' },
        { name: this.$t('weekDay')[6], value: 'Saturday' },
      ]
      return week.slice(startingDay).concat(week.slice(0, startingDay))
    },
    role(member) {
      if (member.roles.includes('owner')) return 'owner'
      if (member.roles.includes('admin')) return 'admin'
      if (member.roles.includes('base')) return 'base'
    },

    colorsHashArray(index) {
      let colors = [
        { hash: '#EB4D82', value: '#EB4D82', name: 'Cherry' },
        { hash: '#DD5DAA', value: '#DD5DAA', name: 'Rose' },
        { hash: '#C072E3', value: '#C072E3', name: 'Lavender' },
        { hash: '#AA5FDC', value: '#AA5FDC', name: 'Amethyst' },
        { hash: '#9358E9', value: '#9358E9', name: 'Grape' },
        { hash: '#644DD6', value: '#644DD6', name: 'Purple' },
        { hash: '#4B61EE', value: '#4B61EE', name: 'Cobalt' }, //primary
        { hash: '#3DBEFF', value: '#3DBEFF', name: 'Blue' },
        { hash: '#09D3E0', value: '#09D3E0', name: 'Turquoise' },
        { hash: '#09D6B7', value: '#09D6B7', name: 'Cyan' },
        { hash: '#10CF84', value: '#10CF84', name: 'Lime' },
        { hash: '#1FCC3F', value: '#1FCC3F', name: 'Malachite' },
        { hash: '#5BCA11', value: '#5BCA11', name: 'Green' },
        { hash: '#7EC710', value: '#7EC710', name: 'Pistachio' },
        { hash: '#ABC900', value: '#ABC900', name: 'Avocado' },
        { hash: '#D9CA2B', value: '#D9CA2B', name: 'Citron' },
        { hash: '#FEBD00', value: '#FEBD00', name: 'Banana' },
        { hash: '#FE992E', value: '#FE992E', name: 'Mango' },
        { hash: '#FF7142', value: '#FF7142', name: 'Pumpkin' },
        { hash: '#FF5467', value: '#FF5467', name: 'Tomato' },
      ]
      if (!(typeof index === 'number')) return colors
      else {
        let i = index % colors.length
        if (i >= 0) return colors[i]
        else return colors[colors.length + i]
      }
    },
    itemsTabs() {
      return [
        { hash: 'Followed', name: 'Followed', component: 'Followed', icon: 'star.svg' },
        // { hash: 'Personal', name: 'Your Schedule', component: 'Personal', icon: 'pcalendar.svg' },
        // { hash: 'PersonalCopy', name: 'PersonalCopy', component: 'PersonalCopy', icon: 'profile.svg' },
        // {name: 'Follow', component: 'Follow', icon: 'plus.svg'},
      ]
    },
    accountTypeOptions() {
      return [
        { name: this.$t('changeToOwner'), key: 'owner' },
        { name: this.$t('changeToAdmin'), key: 'admin' },
        { name: this.$t('changeToMember'), key: 'base' },
      ]
    },
    getTimezoneName(timezone) {
      let timezoneObj = this.$store.state.timezonesGlobal.find((x) => x.value === timezone)
      return timezoneObj.name
    },
    followNotificationSettings() {
      return [
        { name: this.$t('timeOffs'), key: 'time-offs' },
        { name: this.$t('scheduleChanges'), key: 'after-deadline-changes' },
      ]
    },
    avatars() {
      return ['bear.svg', 'owl.svg', 'alien.svg', 'bunny.svg', 'fox.svg', 'frog.svg', 'monkey.svg', 'robot.svg']
    },
    getEmoji(emojiRef) {
      return '<span class="emoji">' + emojis[emojiRef] + '</span>'
    },
    mountStripeScript() {
      if (!this.$store.state.stripeScriptLoaded) {
        Vue.loadScript('https://js.stripe.com/v3')
          .then(() => {})
          .catch((e) => {
            // TODO show some nice error to the user
            console.error('not loaded script', e)
          })
      }
    },
    teamSettingsTabs() {
      return [
        {
          hash: 'TeamGeneralSettings',
          name: this.$t('teamGeneralSettingsTabName'),
          shortName: this.$t('teamGeneralSettingsTabName'),
          component: 'TeamGeneralSettings',
        },
        {
          hash: 'TeamWorkScheduleSettings',
          name: this.$t('teamWorkScheduleSettingsTabName'),
          shortName: this.$t('teamWorkScheduleSettingsShortTabName'),
          component: 'TeamWorkScheduleSettings',
        },
        {
          hash: 'TeamWorkplacesSettings',
          name: this.$t('teamWorkplacesSettingsTabName'),
          shortName: this.$t('teamWorkplacesSettingsTabName'),
          component: 'TeamWorkplacesSettings',
        },
        {
          hash: 'TeamMembersSettings',
          name: this.$t('teamMembersSettingsTabName'),
          shortName: this.$t('teamMembersSettingsTabName'),
          component: 'TeamMembersSettings',
        },
        { hash: 'TeamBilling', name: this.$t('teamBillingTabName'), shortName: this.$t('teamBillingTabName'), component: 'TeamBilling' },
        {
          hash: 'TeamIntegrationsSettings',
          name: this.$t('teamIntegrationsTabName'),
          shortName: this.$t('teamIntegrationsTabName'),
          component: 'TeamIntegrationsSettings',
        },
      ]
    },
    getUserSettingsTabs() {
      return [
        { hash: 'UserProfileSettings', name: this.$t('userProfile'), component: 'UserProfileSettings' },
        { hash: 'PreferencesSettings', name: this.$t('preferences'), component: 'PreferencesSettings' },
        { hash: 'NotificationsSettings', name: this.$t('notifications'), component: 'NotificationsSettings' },
        // {name: this.$t('workplaces'), component: 'WorkplacesSettings'},
      ]
    },
    getPlans(type) {
      if (type === 'Pro') {
        return [
          { name: this.$t('billedAnnually'), value: 'proYearly', stripeName: 'proYearly' },
          { name: this.$t('billedMonthly'), value: 'proMonthly', stripeName: 'proMonthly', planName: 'Pro Plan' },
        ]
      } else {
        return [
          { name: this.$t('billedAnnually'), value: 'standardYearly', stripeName: 'standardYearly' },
          { name: this.$t('billedMonthly'), value: 'standardMonthly', stripeName: 'standardMonthly' },
        ]
      }
    },
    getJSONFromComponentName(name) {
      let componentsArray = [
        { hash: 'Calendar', name: 'Calendar', component: 'Calendar' },
        { hash: 'UserSettings', name: 'Settings', component: 'UserSettings', icon: 'settings.svg' },
        { hash: 'AdminSettings', name: 'AdminSettings', component: 'AdminSettings', icon: 'settings.svg' },
        { hash: 'TeamMate', name: 'TeamMate', component: 'Personal', icon: 'pcalendar.svg' },
      ]
      componentsArray.push(...this.getUserSettingsTabs())
      componentsArray.push(...this.teamSettingsTabs())
      componentsArray.push(...this.itemsTabs())
      let ret = componentsArray.find((x) => x.hash === name)
      if (!ret) {
        ret = componentsArray.find((x) => x.hash === 'TeamMate')
      }
      return ret
    },
    getAvatar(person) {
      if (person.avatar) return person.avatar

      if (person.avatarIndex == undefined) {
        person.avatarIndex = Math.floor(Math.random() * this.avatars().length)
      }

      return require('@/assets/avatars/' + this.avatars()[person.avatarIndex])
    },
  },
}
</script>
